import {
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  TEXT,
  IMAGE,
  ImageDefinition
} from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import { isMobile } from 'react-device-detect';

export const Quote3: Translator = sequence => {
  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Card':
        return {
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'center'
          },
          items: [
            CardHelper({} as ItemOfType<'Card'>, {
              width: '80vw',
              height: 'auto',
              clearStyles: 'sm',
              extraItems: [
                {
                  type: LAYOUT_COLUMNS,
                  id: '1',
                  values: {
                    gridTemplateColumns: isMobile ? '1fr' : '1fr 3fr'
                  },
                  items: [
                    {
                      id: item.pictures?.[0].id,
                      type: IMAGE,
                      values: {
                        url: item.pictures?.[0].mediaUrl,
                        alt: item.pictures?.[0].name,
                        width: '200px',
                        height: '200px'
                      },
                      items: []
                    } as ImageDefinition,
                    {
                      id: `${item.id}_list`,
                      type: LAYOUT_LIST,
                      values: {
                        align: 'left',
                        width: '100%'
                      },
                      items: [
                        {
                          type: TEXT,
                          id: `${item.id}_body`,
                          items: [],
                          values: {
                            value: item.body,
                            variant: 'text'
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            })
          ]
        };
      default:
        return null;
    }
  });
};
